import userPlusIcon from '../assets/icons/fontawesome/user-plus-solid.svg';
import {
  faArrowRightFromBracket,
  faArrowRightToBracket,
} from '@fortawesome/pro-regular-svg-icons';

export const authRoutes = {
  agreements: {
    path: '/agreements',
    key: 'agreements',
    value: 'Agreements',
    QADataTag: 'agreementsNav',
  },
  emailCheck: {
    path: '/email-check',
    key: 'email-check',
    value: 'Email check',
    QADataTag: 'emailCheckNav',
  },
  emailConfirmation: {
    path: '/email-confirmation',
    key: 'email-confirmation',
    value: 'Email Confirmation',
    QADataTag: 'emailConfirmationNav',
  },
  login: {
    path: '/login',
    key: 'login',
    value: 'Log In',
    icon: faArrowRightToBracket,
    QADataTag: 'loginNav',
  },
  logout: {
    path: '/logout',
    key: 'logout',
    value: 'Logout',
    icon: faArrowRightFromBracket,
    QADataTag: 'logoutSideNav',
  },
  signup: {
    path: '/signup',
    key: 'signup',
    value: 'Sign Up',
    icon: userPlusIcon.src,
    QADataTag: 'signupNav',
  },
};
